{
  "actions": "Akce"
}
